import React from "react";
import * as domtoimage from "dom-to-image";

export default function SaveButtons() {
  let node = document.querySelector("#img-section");

  const appendToBody = () => {
    console.log();
    document.body.append(arguments[0]);
  };

  function saveCanvas() {
    let bg = document.querySelector(".bg");
    let image = document.querySelector(".image");

    if (image !== null) {
      node.firstChild.style.borderRadius = "0px";
      node.querySelector("#SVG").style.borderRadius = "0px";
      node.style.cssText = "box-shadow:none;";
      console.log(node.style);
      setTimeout(function () {
        domtoimage
          .toPng(bg)
          .then((dataUrl) => {
            const img = new Image();
            img.src = dataUrl;
            img.setAttribute("class", "img-to-download");
            let link_to_download_img = document.createElement("a");
            link_to_download_img.href = img.src;
            link_to_download_img.setAttribute("download", "your_image");
            link_to_download_img.click();
            node.firstChild.style.borderRadius = "25px";
            node.querySelector("#SVG").style.borderRadius = "25px";
          })
          .catch((error) =>
            console.error("oops, something went wrong!", error)
          );
      }, 1000);
    }
  }

  function copyCanvas() {
    let image = document.querySelector(".image");
    if (image !== null) {
      node.firstChild.style.borderRadius = "0px";
      node.querySelector("#SVG").style.borderRadius = "0px";
      setTimeout(function () {
        domtoimage.toBlob(node).then(function (blob) {
          try {
            navigator.clipboard.write([
              // eslint-disable-next-line no-undef
              new ClipboardItem({
                [blob.type]: blob,
              }),
            ]);
          } catch (error) {
            console.error(error);
          }
        });
        node.firstChild.style.borderRadius = "25px";
        node.querySelector("#SVG").style.borderRadius = "25px";
      }, 1000);
    }
  }

  const isNotFirefox = navigator.userAgent.indexOf("Firefox") < 0;

  return (
    <div className="save-btns-container">
      <div className="save-btns">
        <button
          className="save-btn"
          onClick={() => {
            saveCanvas();
          }}
        >
          <svg
            width="45"
            height="35"
            viewBox="0 0 45 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M42.6276 35L2.37238 35C1.06215 35 0 33.5105 0 31.6731L0 3.32692C0 1.48951 1.06215 0 2.37238 0L42.6276 0C43.9379 0 45 1.48951 45 3.32692V31.6731C45 33.5105 43.9379 35 42.6276 35Z"
              fill="#939597"
            />
            <path
              d="M13.8673 18.6824L13.8764 18.6904L13.8851 18.6989L21.551 26.1512C21.5516 26.1518 21.5521 26.1524 21.5527 26.1529C21.6704 26.2644 21.8126 26.3537 21.9715 26.4139C22.1311 26.4744 22.3031 26.5038 22.4765 26.4996L22.4765 26.4995H22.4885H22.5114V26.4993L22.5234 26.4996C22.6969 26.5038 22.8689 26.4744 23.0285 26.4139C23.1873 26.3537 23.3294 26.2644 23.4472 26.153L31.1149 18.6989L31.1236 18.6904L31.1327 18.6824C31.2509 18.5781 31.3433 18.4536 31.4058 18.3178C31.4683 18.1821 31.5 18.037 31.5 17.8912C31.5 17.7454 31.4683 17.6003 31.4058 17.4645C31.3433 17.3287 31.2509 17.2043 31.1327 17.1L31.1325 17.0998C30.8758 16.8732 30.5319 16.7431 30.1698 16.7431C29.8122 16.7431 29.4724 16.87 29.2167 17.0915L24.6827 21.5623L23.8316 22.4015V21.2062V9.66507C23.8143 9.36189 23.6751 9.06983 23.4322 8.85078C23.1856 8.62836 22.8521 8.5 22.5 8.5C22.1479 8.5 21.8143 8.62836 21.5678 8.85078C21.3249 9.06982 21.1857 9.36187 21.1684 9.66507V21.2062V22.4015L20.3173 21.5623L15.7833 17.0914C15.5276 16.87 15.1878 16.7431 14.8302 16.7431C14.4681 16.7431 14.1242 16.8732 13.8675 17.0998L13.8673 17.1C13.7491 17.2042 13.6567 17.3287 13.5942 17.4645C13.5317 17.6003 13.5 17.7454 13.5 17.8912C13.5 18.037 13.5317 18.1821 13.5942 18.3178C13.6567 18.4537 13.7491 18.5781 13.8673 18.6824Z"
              fill="#F5DF4D"
              stroke="#1E1E1E"
            />
          </svg>
        </button>
        {isNotFirefox ? (
          <button
            className="save-btn"
            onClick={() => {
              copyCanvas();
            }}
          >
            <svg
              width="45"
              height="35"
              viewBox="0 0 45 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M42.6276 35L2.37238 35C1.06215 35 0 33.5105 0 31.6731L0 3.32692C0 1.48951 1.06215 0 2.37238 0L42.6276 0C43.9379 0 45 1.48951 45 3.32692V31.6731C45 33.5105 43.9379 35 42.6276 35Z"
                fill="#939597"
              />
              <path
                d="M14.5 12.2143H28.2778V26C28.2778 26.8284 27.6062 27.5 26.7778 27.5H14.5V12.2143Z"
                fill="#F5DF4D"
                stroke="#1E1E1E"
              />
              <path
                d="M18.7222 9.5H30.9999C31.8284 9.5 32.4999 10.1716 32.4999 11V23.2857C32.4999 24.1141 31.8284 24.7857 30.9999 24.7857H18.7222V9.5Z"
                fill="#F5DF4D"
                stroke="#1E1E1E"
              />
            </svg>
          </button>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
